export type AttributeKinds = 'single' | 'multi' | 'table' | 'check' | 'image' | 'nondisplay';
export type ImageData = {
  imageId: string;
  originWidth: number;
  originHeight: number;
  trimXFrom: number;
  trimYFrom: number;
  trimXTo: number;
  trimYTo: number;
}
export type FontType = {
  name: string; //フォント名
  color: string;
  size: number;
  bold: boolean; //太字
  italic: boolean; //斜体
  underline: boolean;// アンダーライン
  direction: 'vertical-rl' | 'horizontal-tb'; //文字の横書き　'vertical-rl':縦書き　'horizontal-tb':横書き
  orientation: 'mixed' | 'upright' | 'sideways'; //縦書き時の文字の向き　'mixed':混在　'upright':正立 'sideways':側転
  autoFit: boolean; //オートフィット
  yoko: 'left' | 'center' | 'right'; //左右寄せ　'left':左　'center':中央 'right':右
  tate: 'start' | 'center' | 'end'; //上下寄せ　'start':上　'center':中央 'end':下
}
export const defaultFont: FontType = {
  name: 'MS PGothic',
  color: 'black',
  size: 14,
  bold: false,
  italic: false,
  underline: false,
  direction: 'horizontal-tb',
  orientation: 'mixed',
  autoFit: true,
  yoko: 'left',
  tate: 'center'
}
type LineStyleType = 'solid' | 'dotted' | 'dashed' | 'double'
export const isLineStyle = (a: unknown): a is LineStyleType => {
  return a === 'solid' || a === 'dotted' || a === 'dashed' || a === 'double';
}
export type FrameType = {
  display: boolean;
  thickness: number;
  color: string;
  lineStyle: LineStyleType;
  roundCorner: boolean;
  radius: number;
}
export const defaultFrame: FrameType = {
  display: false,
  thickness: 1,
  color: '#000000',
  lineStyle: 'solid',
  roundCorner: false,
  radius: 10
}

export type BaseAttributeModel = {
  languageId: string;
  name: string;
  hint: string;
  frame: FrameType;
  order: number;
  x: number;
  y: number;
  z: number;
  width: number;
  height: number;
  rotation: number;
  description: ItemDescriptionType;
  background: { display: boolean; color: string; };
  goodsId?: string;
  version?: number;
}
export type TableColumnHashType = {
  [key in string]: string;
}
export type ItemDescriptionType = {
  display: boolean;
  content: string;
}

export type SingleAttributeModel = BaseAttributeModel & {
  cardAttributeModel: 'single';
  font: FontType;
  defaultContent: string;
}
export type MultiAttributeModel = BaseAttributeModel & {
  cardAttributeModel: 'multi';
  font: FontType;
  defaultContent: string;
  isMarkdown: boolean;
}
export type TableAttributeModel = BaseAttributeModel & {
  cardAttributeModel: 'table';
  font: FontType;
  columnNames: TableColumnHashType;
}
export type ImageAttributeModel = BaseAttributeModel & {
  cardAttributeModel: 'image';
  defaultImage: ImageData;
}
export type NondispleyAttributeModel = BaseAttributeModel & {
  cardAttributeModel: 'nondisplay';
  defaultContent: string;
}